import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {ResearchPaperDTO} from '../../dto/research-paper';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {CloseableDialogComponent} from '../../../../utils/components/closeable-dialog/closeable-dialog.component';

interface ResearchPaperDialogData {
  paper: ResearchPaperDTO;
  isMobile: boolean;
}

@Component({
  selector: 'app-research-paper-dialog',
  imports: [
    MatDialogContent,
    MatCardModule,
    MatIconModule,
    CloseableDialogComponent,
  ],
  templateUrl: './research-paper-dialog.component.html',
  styleUrl: './research-paper-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResearchPaperDialogComponent implements OnInit {
  private readonly dialogRef: MatDialogRef<ResearchPaperDialogComponent> = inject(MatDialogRef);
  readonly data: ResearchPaperDialogData = inject<ResearchPaperDialogData>(MAT_DIALOG_DATA);

  paper = this.data.paper;

  ngOnInit() {
    this.paper = this.data.paper;
  }

  close(): void {
    this.dialogRef.close();
  }
}
